export const openWindow = (history: any, url: string) => {
  if (isInternalUrl(url)) {
    history.push(url);
  } else {
    window.open(url, '_blank');
  }
};

const isInternalUrl = (img: string) => img.startsWith('/');
